import React from "react";
import { Link } from "react-router-dom";
import { 
  FaFilePdf, 
  FaDownload, 
  FaEye, 
  FaGraduationCap, 
  FaBook, 
  FaBuilding,
  FaUsers,
  FaTrophy,
  FaCheckCircle,
  FaArrowRight
} from "react-icons/fa";
import { MdSchool, MdVerified } from "react-icons/md";

const ProspectusPage = () => {
  const highlights = [
    "Complete course details & curriculum",
    "Eligibility criteria & admission process",
    "Fee structure & scholarship details",
    "Faculty profiles & qualifications",
    "Infrastructure & facilities",
    "Placement records & collaborations",
    "Important dates & deadlines",
    "Hostel & transport facilities"
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100 py-12 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <nav className="flex text-sm text-gray-500">
            <Link to="/" className="hover:text-blue-600">Home</Link>
            <span className="mx-2">/</span>
            <Link to="/admission" className="hover:text-blue-600">Admission</Link>
            <span className="mx-2">/</span>
            <span className="text-blue-600 font-semibold">Prospectus</span>
          </nav>
        </div>
        <div className="bg-gradient-to-r from-purple-600 to-blue-600 rounded-3xl p-8 mb-8 text-white">
          <div className="flex items-center gap-4">
            <div className="bg-white/30 p-4 rounded-2xl">
              <FaFilePdf className="text-4xl" />
            </div>
            <div>
              <h1 className="text-3xl md:text-4xl font-bold">Prospectus 2025-26</h1>
              <p className="text-white/90 mt-2">Download the official prospectus for complete information</p>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-1">
            <div className="bg-white rounded-2xl shadow-xl p-6 sticky top-24">
              <h2 className="text-xl font-bold text-gray-800 mb-4">Download Prospectus</h2>
              <div className="space-y-4">
                <button className="w-full py-4 bg-gradient-to-r from-blue-600 to-green-600 text-white font-semibold rounded-xl hover:from-blue-700 hover:to-green-700 transition-all duration-300 flex items-center justify-center gap-2">
                  <FaDownload /> Download PDF (English)
                </button>
                
                <button className="w-full py-4 bg-gradient-to-r from-orange-600 to-red-600 text-white font-semibold rounded-xl hover:from-orange-700 hover:to-red-700 transition-all duration-300 flex items-center justify-center gap-2">
                  <FaDownload /> Download PDF (Hindi)
                </button>
                
                <button className="w-full py-4 border-2 border-blue-600 text-blue-600 font-semibold rounded-xl hover:bg-blue-50 transition-all duration-300 flex items-center justify-center gap-2">
                  <FaEye /> View Online
                </button>
              </div>
              <div className="border-t border-gray-200 my-6 pt-4">
                <p className="text-sm text-gray-500 mb-2">File Size: 5.2 MB</p>
                <p className="text-sm text-gray-500">Pages: 48</p>
                <p className="text-sm text-gray-500">Last Updated: March 2025</p>
              </div>
              <div className="bg-blue-50 p-4 rounded-xl">
                <p className="text-sm text-gray-600">
                  <span className="font-semibold">📧</span> For hard copy, email us at:<br />
                  <a href="mailto:rdsnursing@gmail.com" className="text-blue-600">rdsnursing@gmail.com</a>
                </p>
              </div>
            </div>
          </div>
          <div className="lg:col-span-2 space-y-6">
            <div className="bg-white rounded-2xl shadow-xl p-6">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">About the Prospectus</h2>
              <p className="text-gray-600 leading-relaxed">
                The R.D.S. NURSING & PARAMEDICAL COLLEGE prospectus provides comprehensive information about 
                courses offered, admission process, fee structure, facilities, faculty, and everything 
                you need to know about joining our institution for the academic session 2025-26.
              </p>
            </div>

            <div className="bg-white rounded-2xl shadow-xl p-6">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">What's Inside</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {highlights.map((item, index) => (
                  <div key={index} className="flex items-start gap-2">
                    <FaCheckCircle className="text-green-600 mt-1 flex-shrink-0" />
                    <span className="text-gray-700">{item}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="bg-white rounded-2xl shadow-xl p-6">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">Quick Preview</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="bg-gray-50 p-4 rounded-xl">
                  <h3 className="font-semibold text-gray-800 mb-2">📚 Courses Offered</h3>
                  <ul className="space-y-1 text-sm text-gray-600">
                    <li>• ANM (Auxiliary Nurse Midwifery)</li>
                    <li>• GNM (General Nursing & Midwifery)</li>
                    <li>• B.Sc. Nursing</li>
                    <li>• D.Pharma (Diploma in Pharmacy)</li>
                  </ul>
                </div>
                <div className="bg-gray-50 p-4 rounded-xl">
                  <h3 className="font-semibold text-gray-800 mb-2">📅 Important Dates</h3>
                  <ul className="space-y-1 text-sm text-gray-600">
                    <li>• Application Start: 1st April 2025</li>
                    <li>• Last Date: 30th June 2025</li>
                    <li>• Merit List: 10th July 2025</li>
                    <li>• Classes Begin: 1st August 2025</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="bg-gradient-to-r from-blue-600 to-green-600 rounded-2xl p-6 text-white">
              <h2 className="text-xl font-bold mb-2">Need a Hard Copy?</h2>
              <p className="text-white/90 mb-4">
                Visit our campus or request a prospectus by mail. Pay ₹200 via DD in favor of 
                "R.D.S. NURSING & PARAMEDICAL COLLEGE" payable at Jaunpur.
              </p>
              <div className="flex gap-4">
                <a href="tel:+917275370808" className="bg-white text-blue-700 px-4 py-2 rounded-lg font-semibold hover:bg-blue-50">
                  Call Us
                </a>
                <a href="mailto:rdsnursing@gmail.com" className="border-2 border-white text-white px-4 py-2 rounded-lg font-semibold hover:bg-white/10">
                  Email Us
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProspectusPage;